import type { Media } from '@wineryxplorer/shared';

interface ImageLoadState {
  loaded: boolean;
  loading: boolean;
  error: boolean;
  url?: string;
  blurUrl?: string;
  errorMessage?: string;
  retryCount?: number;
}

interface DebugInfoProps {
  currentIndex: number;
  images: Media[];
  availableImagesCount: number;
  isPaused: boolean;
  isTransitioning: boolean;
  isTouching: boolean;
  cloudName: string;
  imageStates: Map<string, ImageLoadState>;
}

export const DebugInfo = ({
  currentIndex,
  images,
  availableImagesCount,
  isPaused,
  isTransitioning,
  isTouching,
  cloudName,
  imageStates,
}: DebugInfoProps) => {
  return (
    <div className="absolute top-2 right-2 bg-black/50 text-white text-xs p-1 rounded max-w-xs">
      <div>{currentIndex + 1}/{images.length} | Available: {availableImagesCount}</div>
      <div>Paused: {isPaused ? 'Yes' : 'No'} | Transitioning: {isTransitioning ? 'Yes' : 'No'}</div>
      <div>Touching: {isTouching ? 'Yes' : 'No'} | Cloud: {cloudName || 'Loading...'}</div>
      {images.length > currentIndex && (
        <div>
          Current: {imageStates.get(images[currentIndex].id)?.loaded ? 'Loaded' : 
                   imageStates.get(images[currentIndex].id)?.loading ? 'Loading' : 
                   imageStates.get(images[currentIndex].id)?.error ? 'Error' : 'Pending'}
        </div>
      )}
    </div>
  );
};